import { ForgotPasswordRequestBody } from '@aaa-ncnu-ie/mypolicy-api-registrations';
import { useMutation } from '@tanstack/react-query';

import axios from '../axios';

const forgotPassword = async (email: string) => {
  const { data } = await axios.post(
    `${import.meta.env.VITE_REGISTRATIONS_API_URL}/v1/forgot-password`,
    {
      email,
    } as ForgotPasswordRequestBody
  );
  return data;
};

export const useForgotPasswordMutation = () =>
  useMutation({
    mutationFn: (email: string) => forgotPassword(email),
  });
